import api from './api';

// The billing API accepts at most 100 records per request. Load every page so
// the hosted accounts table can search and paginate the complete list locally.
export const loadAllHostedAccounts = async () => {
  const objects = [];
  let offset = 0;
  while (true) {
    const response = await api.OrganizationBilling.hostedAccounts(offset, 100);
    const page = response?.Data ?? response?.data ?? response;
    const rows = page?.Objects ?? page?.objects ?? [];
    objects.push(...rows);
    offset += rows.length;
    const endOfResults = page?.EndOfResults ?? page?.endOfResults;
    const totalRecords = page?.TotalRecords ?? page?.totalRecords;
    if (
      !rows.length ||
      endOfResults === true ||
      (totalRecords != null && offset >= totalRecords)
    ) {
      return {
        Objects: objects,
        TotalRecords: objects.length,
        EndOfResults: true
      };
    }
  }
};
